// CRC-32C (Castagnoli), RFC 3720 / standard vector "123456789" = 0xe3069283.
// The QR code already has Reed-Solomon correction; this checksum protects the
// LumiChat application envelope after optical decoding.
const POLY_REFLECTED = 0x82f63b78;

const TABLE = new Uint32Array(256);
for (let i = 0; i < 256; i++) {
  let value = i;
  for (let bit = 0; bit < 8; bit++) {
    value = (value >>> 1) ^ ((value & 1) ? POLY_REFLECTED : 0);
  }
  TABLE[i] = value >>> 0;
}

export function crc32c(bytes) {
  let crc = 0xffffffff;
  for (const byte of bytes) crc = (crc >>> 8) ^ TABLE[(crc ^ byte) & 0xff];
  return (crc ^ 0xffffffff) >>> 0;
}
